import { put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getNetworkThreadSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getNetworkThreadLoading())
      const response = yield axios.get(
        '/getThreadNetworks',
        {
          MAC: rMac
        }
      )
      const bodyStatus = response?.data?.status;
      if (response?.status === 200 && bodyStatus === 200) {
        yield put(actions.getNetworkThreadSuccess(response?.data));
      } else {
        yield put(actions.getNetworkThreadFail());
        const state = yield select(s => s.networkThread);
        if (!state.networkThreadLoaded) {
          yield put(actions.threadInitialLoadFailed());
        }
      }
    } catch (error) {
      yield put(actions.getNetworkThreadFail());
      const state = yield select(s => s.networkThread);
      if (!state.networkThreadLoaded) {
        yield put(actions.threadInitialLoadFailed());
      }
    }
  }
}

export function* getThreadRadioStatusSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getThreadRadioStatusLoading());
      const response = yield axios.post('/getThreadRadioStatus', { MAC: rMac });
      const bodyStatus = response?.data?.status;
      if (response?.status === 200 && bodyStatus === 200) {
        yield put(actions.getThreadRadioStatusSuccess(response?.data));
      } else {
        yield put(actions.getThreadRadioStatusFail());
        const state = yield select(s => s.networkThread);
        if (!state.radioStatusLoaded) {
          yield put(actions.threadInitialLoadFailed());
        }
      }
    } catch (error) {
      yield put(actions.getThreadRadioStatusFail());
      const state = yield select(s => s.networkThread);
      if (!state.radioStatusLoaded) {
        yield put(actions.threadInitialLoadFailed());
      }
    }
  }
}

export function* toggleNetworkThreadSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const enabled = action.payload;
  if (sessionToken) {
    try {
      yield put(actions.toggleNetworkThreadLoading());
      const endpoint = enabled ? '/enableThreadRadio' : '/disableThreadRadio';
      const response = yield axios.post(endpoint, { MAC: rMac });
      if (response?.status === 200) {
        yield put(actions.toggleNetworkThreadSuccess(response?.data));
      } else {
        yield put(actions.toggleNetworkThreadFail());
      }
    } catch (error) {
      yield put(actions.toggleNetworkThreadFail());
    }
  }
}

